document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.tab-button');
  const contents = document.querySelectorAll('.tab-content');
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.querySelector('.lightbox-image');
  const closeBtn = document.querySelector('.lightbox-close');
  const nextBtn = document.querySelector('.lightbox-next');
  const prevBtn = document.querySelector('.lightbox-prev');

  let currentImages = [];
  let currentIndex = 0;

  function showLightbox(index) {
    if (currentImages.length === 0) {
        return;
    }
    const plusLength = index + currentImages.length;
    const wrappedIndex = plusLength % currentImages.length;
    currentIndex = wrappedIndex;
    lightboxImg.src = currentImages[currentIndex].src;
    lightbox.style.display = 'flex';
  }
  function wrapGalleryImages(content) {
    const gallery = content.querySelector(".gallery-group");
    if (gallery) {
      const images = gallery.querySelectorAll("img");
      images.forEach(function (img) {
        const alreadyWrapped = img.closest('.gallery-item-wrapper');
        if (!alreadyWrapped) {
          const link = document.createElement("a");
          link.href = img.src;
          link.className = "gallery-item"; 
          const parent = img.parentElement;
          let wrapper;
          if (parent.tagName.toLowerCase() === 'p') {
            wrapper = document.createElement("div");
            wrapper.className = "gallery-item-wrapper";
            parent.replaceWith(wrapper);
          } else {
            wrapper = document.createElement("div");
            wrapper.className = "gallery-item-wrapper";
            parent.insertBefore(wrapper, img);
          }
          wrapper.appendChild(link);
          link.appendChild(img);
        }
      });
    }
  }

  contents.forEach(wrapGalleryImages);

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      buttons.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));
      this.classList.add('active');
      const tabId = this.getAttribute('data-tab');
      const activeContent = document.getElementById(tabId);
      activeContent.classList.add('active');
      wrapGalleryImages(activeContent);
    });
  });
  document.body.addEventListener('click', function (e) {
    if (e.target.tagName.toLowerCase() === 'img' && e.target.closest('.tab-content.active')) {
      const activeContent = e.target.closest('.tab-content.active');
      currentImages = Array.from(activeContent.querySelectorAll('.gallery-group img'));
      currentIndex = currentImages.indexOf(e.target);
      showLightbox(currentIndex);
    }
  });
  closeBtn.addEventListener('click', () => {
    lightbox.style.display = 'none';
    lightboxImg.src = '';
  });
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
      lightboxImg.src = '';
    }
  });
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    showLightbox(currentIndex + 1);
  });
  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    showLightbox(currentIndex - 1);
  });
});
